import { useNavigate, useParams } from "react-router-dom";
import { Button } from "antd";
import {
  EditOutlined,
  UserAddOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { Tooltip } from "antd";
//import { PropertyUnits } from "../../Data/Data";
import skyIcon from "../../assets/landing/ri_building-2-fill.svg";
import Table from "../../components/Table/LandLordTable";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { unitStatus } from "../../constants/commonConstants";
import { useThunk } from "../../hooks/useThunk";
import {
  editUnit,
  fetchUnitsByPropertyId,
  fetchUserProperties,
  getSingleProperty,
} from "../../store/thunks/propertyThunks";
import EditableCell from "./EditableCell";
import showToast from "../../utils/toastNotifications";
import { Pagination } from "antd";
import Loader from "../../components/Common/Loader";
//import ConfirmationModal from "../../components/Model/ConfirmationModal";
import { useConfirmation } from "../../hooks/useConfirmation";

const fieldNames = {
  unitName: "unitName",
  deposit: "deposit",
  monthlyRent: "monthlyRent",
};

const SummaryCard = ({ label, value, color }) => (
  <div className="text-center px-4 lg:px-5 py-[10px] w-full md:w-[160px] h-auto lg:h-[86px] rounded-[5px] shadow-[0px_2px_4px_2px_#0000000F] bg-[#FFFFFF1A]">
    <p className="text-[10px] sm:twxt-[12px] md:text-[13px] lg:text-[14px] font-inter font-[600] leading-[100%] tracking-[0%] bg-gradient-to-b from-[#4E6CF0] to-[#8442E3] bg-clip-text text-transparent">
      {label}
    </p>
    <h3
      className="text-[22px] sm:twxt-[28px] md:text-[34px] lg:text-[40px] mt-2 font-inter font-[600] leading-[100%] tracking-[0%]
             bg-gradient-to-b from-[#4E6CF0] to-[#8442E3] bg-clip-text text-transparent"
    >
      {value}
    </h3>
  </div>
);

const LandLordTestSummary = () => {
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [editableField, setEditableField] = useState("");
  const [data, setData] = useState({
    key: "",
    id: "",
    unitName: "",
    deposit: "",
    rent: "",
  });

  // Fetch property data from slice
  const { propertyId } = useParams();
  const [propertyData, setPropertyData] = useState({});
  const [isEditedUnit, setIsEditedUnit] = useState(false);
  const properties = useSelector((state) => state.property.properties);

  const [doGetSingleProperty, isgetSingleProperty, getSinglePropertyError] =
    useThunk(getSingleProperty);
  const [doEditProperty, isEditingProperty, editPropertyError] =
    useThunk(editUnit);
  const [doFetchUnits, isFetchingUnits, fetchUnitsError] = useThunk(
    fetchUnitsByPropertyId
  );

  const [fetchedUnits, setFetchedUnits] = useState([]);

  const [totalRecords, setTotalRecords] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const { requestConfirmation, confirmation, confirm, cancel } =
    useConfirmation();

  const fetchAndSetPropertyData = async (page = 1, pageSize = 4) => {
    const offset = (page - 1) * pageSize;

    let result;
    let fetchedProps;

    if(propertyId !== undefined){
      result = await doFetchUnits({ propertyId, offset, limit: pageSize });
      fetchedProps = await doGetSingleProperty({ propertyId: propertyId });
    }

    if (result?.success) {
      setFetchedUnits(result?.response?.data?.units);
      setTotalRecords(result?.response?.data?.pagination?.total || 0);
    }

    if (fetchedProps?.success) {
      // console.log('fetched props', fetchedProps);
      setPropertyData(fetchedProps?.response?.data);
    }

    setIsEditedUnit(false);

    const selectedProperty = properties.find(
      (property) => property._id === propertyId
    );
    if (selectedProperty) {
      setPropertyData(selectedProperty);
      const element = document.getElementById(`${data.id}-${editableField}`);
      element?.focus();
    }
  };

  useEffect(() => {
    fetchAndSetPropertyData(currentPage, pageSize);
  }, [currentPage, pageSize, propertyId, isEditing]);

  const onPageChange = (page) => {
    // console.log('Pagination hit');
    setCurrentPage(page);
    fetchAndSetPropertyData(page, pageSize);
  };

  const handleEditClick = (record) => {
    setData({
      key: record.id,
      id: record.id,
      unitName: record.unitName,
      deposit: record.deposit,
      rent: record.rent,
    });
    setIsEditing(true);

    setTimeout(() => {
      const element = document.getElementById(
        `${record.id}-${fieldNames.unitName}`
      );
      element?.focus();
    }, 0);
  };

  const handleViewPaymentsClick = (unitMongoId, userId) => {
    const qs = userId ? `?userId=${userId}` : "";
    navigate(`/landlords/manage-property/payments/${unitMongoId}${qs}`);
  };

  const handleEditTenant = (unit) => {
    // console.log('Handle edit or add tenant', unit);
    if (unit.status === unitStatus.VACANT) {
      navigate(
        `/landlords/manage-property/${propertyId}/${unit?.item?.[0]._id}/add-tenant`
      );
    } else {
      navigate(
        `/landlords/manage-property/${propertyId}/${unit?.item?.[0]._id}/edit-tenant`
      );
    }
  };

  function addVacantAndOccupiedCounts(property) {
    let vacant = 0;
    let occupied = 0;

    for (const unit of property.units || []) {
      if (unit.status === "VACANT") {
        vacant += 1;
      } else if (unit.status === "OCCUPIED") {
        occupied += 1;
      }
    }

    return {
      ...property,
      vacant,
      occupied,
    };
  }

  const updatedProperty = addVacantAndOccupiedCounts(propertyData);

  // pick the units from API pagination if present, otherwise from the property object
  const sourceUnits = (fetchedUnits?.length ? fetchedUnits : propertyData?.units) || [];

  const transformedData = sourceUnits.map((unit) => ({
    key: unit?.unitId,
    id: unit?.unitId,
    unitName: unit?.unitName || "N/A",
    deposit: unit?.securityDepositAmount?.amount ?? 0,
    rent: unit?.currentMonthRent ?? 0,
    unitCode: unit?.unitCode || "N/A",
    occupied: !!unit?.tenant,
    tenantName: unit?.tenant?.name || "N/A",
    phone: unit?.tenant?.phoneNumber || "N/A",
    status: unit?.status || "Pending",
    payments: unit?.unpaidMonths || [],
   // paymentStatus: unit?.paymentStatus || "On Time",
    item: [unit],
  }));

  const nestedColumns = {
    dataField: "item",
    columns: [
      {
        title: (
          <span className="text-[#4772F1] font-bold font-inter text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px]">
            Tenant Name
          </span>
        ),
        dataIndex: "tenantName",
        key: "tenantName",
        render: (_, record) => record.tenant?.name || "N/A",
      },
      {
        title: (
          <span className="text-[#4772F1] font-bold font-inter text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px]">
            Phone Number
          </span>
        ),
        dataIndex: "phone",
        key: "phone",
        render: (_, record) => record.tenant?.phoneNumber || "N/A",
      },
      {
        title: (
          <span className="text-[#4772F1] font-bold font-inter text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px]">
            Unit Code
          </span>
        ),
        dataIndex: "unitCode",
        key: "unitCode",
        render: (unitCode) => unitCode || "N/A",
      },

    ],
  };

  const handleSave = async (record) => {
    if (record.status === unitStatus.OCCUPIED) {
      if (data.deposit !== record.deposit) {
        showToast("error", "Deposit can not be edited for an occupied unit.");
        return;
      }
    }

    // Trnsform object before send
    const transformed = {};

    // Compare and add only if changed
    if (data.unitName !== record.unitName) {
      transformed.unitName = data.unitName;
    }

    if (Number(data.deposit) !== Number(record.deposit)) {
      transformed.securityDepositAmount = Number(data.deposit);
    }

    if (Number(data.rent) !== Number(record.rent)) {
      transformed.rentAmountMonthly = {
        amount: Number(data.rent),
      };
    }

    if (Object.keys(transformed).length === 0) {
      showToast("info", "No changes detected. Nothing to update.");
      return;
    }

    const result = await doEditProperty({
      unitId: record.item[0]._id,
      unitData: transformed,
    });

    if (result.success) {
      showToast("success", "Unit updated successfully.");
      // console.log('edited object', result?.response?.data);
      setIsEditedUnit(true);
      setIsEditing(false);
      setData({
        key: "",
        id: "",
        unitName: "",
        deposit: "",
        rent: "",
      });
    }
  }
  const getPaymentStatus = (lastPaidUpToISO) => {
    if (!lastPaidUpToISO) return "Late"; // no record => treat as late

    const now = new Date();
    const currIdx = now.getFullYear() * 12 + now.getMonth(); // 0-based month
    const paid = new Date(lastPaidUpToISO);
    const paidIdx = paid.getFullYear() * 12 + paid.getMonth();

    if (paidIdx > currIdx) return "Advance";  // future months paid (10,11,12,…)
    if (paidIdx === currIdx) return "On Time"; // this month (9)
    return "Late";                              // past months (8,7,6,…)
  };

  const columns = [
    { title: "Unit ID", dataIndex: "id", key: "id" },
    {
      title: "Unit Name",
      dataIndex: "unitName",
      key: "unitName",
      render: (text, record) =>
        isEditing && record.id === data.id ? (
          <EditableCell
            value={data.unitName}
            record={record}
            field={fieldNames.unitName}
            onChange={(val) => setData((prev) => ({ ...prev, unitName: val }))}
            isFocused={editableField === fieldNames.unitName}
            setEditableField={setEditableField}
          />
        ) : (
          text
        ),
    },
    {
      title: "Deposit",
      dataIndex: "deposit",
      key: "deposit",
      render: (text, record) => {
        const depositValue = text || 0;
        const displayValue = depositValue === 0 ? "-" : `UGX ${depositValue}`;
        return isEditing && record.id === data.id ? (
          <EditableCell
            value={data.deposit}
            record={record}
            field={fieldNames.deposit}
            onChange={(val) => setData((prev) => ({ ...prev, deposit: val }))}
            isFocused={editableField === fieldNames.deposit}
            setEditableField={setEditableField}
            disabled={record.status === unitStatus.OCCUPIED} // Disable if occupied
          />
        ) : (
          displayValue
        );
      },
    },
    {
      title: "Monthly Rent",
      dataIndex: "rent",
      key: "rent",
      render: (text, record) => {
        const rentValue = text || 0;
        const displayValue = rentValue === 0 ? "-" : `UGX ${rentValue}`;
        return isEditing && record.id === data.id ? (
          <EditableCell
            value={data.rent}
            record={record}
            field={fieldNames.monthlyRent}
            onChange={(val) => setData((prev) => ({ ...prev, rent: val }))}
            isFocused={editableField === fieldNames.monthlyRent}
            setEditableField={setEditableField}
          />
        ) : (
          displayValue
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <span
          className={`capitalize text-[9px] sm:text-xs leading-6 rounded-[15px] h-[28px] flex justify-center items-center gap-1 md:text-[.75rem] w-[86px] ${text === unitStatus.VACANT
              ? "text-green-action bg-[#07C01D] bg-opacity-15"
              : "text-orange-action bg-[#DEA156] bg-opacity-15"
            }`}
        >
          {text}
        </span>
      ),
    },
    {
      title: (
        <span className="text-[#4772F1] font-bold font-inter text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px]">
          Payment
        </span>
      ),
      dataIndex: "payment",
      key: "payment",
      render: (_, record) => {
        // If unit is vacant, show blank/empty centered
        if (record.status === unitStatus.VACANT) {
          return <span className="flex justify-center">-</span>;
        }

        const lastPaidUpTo = record.item?.[0]?.lastPaidUpTo || null;
        const status = getPaymentStatus(lastPaidUpTo);

        let statusClass = "";
        switch (status) {
          case "Late":
            statusClass = "text--action text-[#ffcccb] bg-[#ff6666]";
            break;
          case "On Time":
            statusClass = "text--action text-[#E5F6DF] bg-[#9BDFB5]";
            break;
          case "Advance":
            statusClass = "text--action text-[#CAE9F5] bg-[#8DA7F6]";
            break;
          default:
            statusClass = "text-gray-500 bg-gray-200";
        }

        return (
          <span
            className={`capitalize text-[9px] sm:text-xs leading-6 rounded-[15px] h-[28px] flex justify-center items-center gap-1 md:text-[.75rem] w-[86px] ${statusClass}`}
            title={lastPaidUpTo ? `Paid up to: ${new Date(lastPaidUpTo).toDateString()}` : "No payment on record"}
          >
            {status}
          </span>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        const editing = record.id === data.id;
        return editing ? (
          <div className="flex gap-2">
            <Button
              size="small"
              className="text-gray-600 border-gray-600 w-[49px] lg:w-[69px] h-7 rounded-[15px] font-normal leading-6 tracking-[0%] text-[9px] sm:text-[10px] md:text:[11px] lg:text-[12px] font-inter flex items-center justify-center text-center"
              onClick={() => {
                setIsEditing(false);
                setData({
                  key: "",
                  id: "",
                  unitName: "",
                  deposit: "",
                  rent: "",
                });
              }}
            >
              Cancel
            </Button>
            <Button
              size="small"
              className="text-[#07C01D] border-[#07C01D] w-[49px] lg:w-[69px] h-7 rounded-[15px] font-normal leading-6 tracking-[0%] text-[9px] sm:text-[10px] md:text:[11px] lg:text-[12px] font-inter flex items-center justify-center text-center"
              onClick={() => handleSave(record)}
            >
              Save
            </Button>
          </div>
        ) : (
          <div className="flex gap-2">
            {/*  <Button
              size="small"
              icon={<EditOutlined />}
              className="text-[#C46500] border-[#C46500] w-[49px] lg:w-[69px] h-7 flex items-center justify-center text-center rounded-[15px] font-normal leading-6 tracking-[0%] text-[9px] sm:text-[10px] md:text-[11px] lg:text-[12px] font-inter"
              onClick={() => handleEditClick(record)}
            >
              Edit
            </Button>*/}

            {record.status === unitStatus.OCCUPIED && (<Button
              size="small"
              icon={ <UserAddOutlined />}
              onClick={() => {
                handleEditTenant(record);
              }}
              className={` rounded-[15px] font-normal w-[92px] lg:w-[112px] h-7 leading-6 tracking-[0%] text-[9px] sm:text-[10px] md:text-[11px] lg:text-[12px] font-inter flex items-center justify-center text-[#07C01D] border-[#07C01D]`}
            >
              {record.status === unitStatus.OCCUPIED
                ? "View Tenant"
                : "View Tenant"}
            </Button>)}
            {record.status !== unitStatus.VACANT && (
              <Button
                size="small"
                icon={<WalletOutlined />}
                onClick={() => handleViewPaymentsClick(record.item?.[0]?._id, // unitId (Mongo _id)
                  record.item?.[0]?.tenant?._id || null // userId (optional)
                )
                }
                className="text-[#0000FF] border-[#0000FF] w-[110px] lg:w-[130px] h-7 rounded-[15px] font-normal leading-6 tracking-[0%] text-[9px] sm:text-[10px] md:text-[11px] lg:text-[12px] font-inter flex items-center justify-center text-center"
              >
                View Payments
              </Button>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className="p-4 sm:p-6 md:p-[30px]">
      <div className="flex justify-center mb-4 sm:mb-6 md:mb-[30px]">
        <div className="flex justify-between items-center bg-white p-6 md:p-[30px] h-auto xl:h-[146px] gap-3 w-full lg:w-[1080px] xl:w-full  rounded-[10px] flex-wrap shadow-[0px_4px_4px_0px_#0000000F]">
          <div>
            <h2 className="text-[22px] flex leading-[100%] tracking-[0%] font-semibold  text-[#4772F1] font-inter">
              <img
                src={skyIcon}
                alt="Sky Icon"
                className="w-[29px] h-[29px] mr-2 relative -top-1 "
              />
              <Tooltip
                title={propertyData?.propertyName}
                placement="topLeft"
              >
                <span
                  className="max-w-[280px] truncate inline-block align-middle"
                >
              {propertyData?.propertyName}
                </span>
              </Tooltip>
            </h2>
            <p className="text-[16px] text-[#696969] leading-[100%] tracking-[0%] font-[500] font-inter mt-1 ml-[37px]">
              {propertyData?.location?.length > 0 &&
                `${propertyData.location[0].area}, ${propertyData.location[0].city}`}
            </p>
          </div>
          <div className="flex gap-6 mt-4 sm:mt-0">
            <SummaryCard
              label="Total Units"
              value={propertyData?.units?.length}
              color="text-[#873FE2]"
            />
            <SummaryCard
              label="Occupied Units"
              value={updatedProperty?.occupied}
              color="text-[#873FE2]"
            />
            <SummaryCard
              label="Vacant Units"
              value={updatedProperty?.vacant}
              color="text-[#873FE2]"
            />
          </div>
        </div>
      </div>

      <div className="relative">
        {(isgetSingleProperty || isEditingProperty || isFetchingUnits) && (
          <div className="flex justify-center items-center absolute z-50 inset-0 ">
            <Loader color="#4772F1" />
          </div>
        )}

        <div className="overflow-x-auto">
          <Table
            dataSource={transformedData}
            columns={columns}
            hasSubTable={true}
            subTableConfig={nestedColumns}
            rowKey="key"
          />
        </div>

        <div className="flex justify-center pb-5">
          <Pagination
            current={currentPage}
            total={totalRecords}
            pageSize={pageSize}
            onChange={onPageChange}
            showSizeChanger={false}
            className="custom-pagination"
            hideOnSinglePage={true}
            showLessItems
          />
        </div>
      </div>

      {/*   <ConfirmationModal
        isOpen={confirmation.isOpen}
        options={confirmation.options}
        onConfirm={confirm}
        onCancel={cancel}
      />*/}
    </div>
  );
};

export default LandLordTestSummary;
